import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'medium', onClick }) => {
  const sizes = {
    small: 'h-16',
    medium: 'h-24',
    large: 'h-32 md:h-40'
  };

  // Using a direct Cloudinary URL
  const logoUrl = 'https://res.cloudinary.com/dsagh0nbi/image/upload/v1730834506/bond_coffee/nnurbq8jxfcfoueghpdh.svg';

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior: go to home page
      window.location.href = '/';
    }
  };

  return (
    <div 
      className={`${sizes[size]} ${className} cursor-pointer hover:opacity-80 transition-opacity duration-300`}
      onClick={handleClick}
    >
      <img 
        src={logoUrl}
        alt="Bond Coffee Roasters" 
        className="h-full w-auto object-contain select-none"
      />
    </div>
  );
};

export default Logo;